var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueCarve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2556,
    height: 2623,
    viewBox: "0 0 2556 2623",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1172.48 682.23C1381 473.707 1709.52 473.138 1905.15 680.523C2100.6 888.098 2090.17 1226.47 1881.65 1435L1378.73 1937.91C1454.94 2126.34 1463.09 2356.66 1414.56 2622.06L2230.83 1805.79C2644.65 1391.96 2665.5 720.522 2277.46 308.596C1889.42 -103.331 1237.12 -101.625 823.491 312.008L0.0176663 1135.48C256.69 1089.23 477.723 1109.32 667.668 1187.8L1172.86 682.609L1172.48 682.23Z",
    fill: "url(#paint0_linear_245_80439)",
    fillOpacity: 0.15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_245_80439",
    x1: 1365.41,
    y1: 34.8596,
    x2: 752.162,
    y2: 913.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#338AF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCarve);
export default __webpack_public_path__ + "static/media/Blue-carve.a12020e6759bf00bd069c175ff7c69f1.svg";
export { ForwardRef as ReactComponent };